<template>
  <header
    ref="headerEl"
    class="bp-header"
  >
    <NuxtLink
      to="/"
      class="bp-header__id"
      aria-label="Daniel Hagen, home"
    >
      <BlueprintMonogram class="bp-header__mark" />
      <span>
        <span class="bp-header__name">Daniel Hagen</span>
        <span class="bp-header__role bp-label">Principal DevOps Engineer</span>
      </span>
    </NuxtLink>
    <nav
      class="bp-nav"
      aria-label="Primary"
    >
      <a href="/#about">
        <span
          class="bp-nav__num"
          aria-hidden="true"
        >01</span>Notes
      </a>
      <a href="/#record">
        <span
          class="bp-nav__num"
          aria-hidden="true"
        >02</span>Record
      </a>
      <a href="/#practice">
        <span
          class="bp-nav__num"
          aria-hidden="true"
        >03</span>Practice
      </a>
      <a
        href="/#contact"
        class="bp-nav__cta"
      >
        Contact
      </a>
    </nav>
  </header>
</template>

<script setup lang="ts">
const headerEl = ref<HTMLElement | null>(null)

// Anchors use scroll-padding-top: var(--bp-header-h). The stylesheet fallback
// covers the stacked and single-row headers; this replaces it with the real
// border box so a wrapping row cannot hide the target.
const syncHeaderOffset = () => {
  const el = headerEl.value
  if (!el) return
  const height = Math.ceil(el.getBoundingClientRect().height)
  document.documentElement.style.setProperty('--bp-header-h', `${height}px`)
}

let headerObserver: ResizeObserver | undefined

onMounted(() => {
  syncHeaderOffset()
  const el = headerEl.value
  if (!el || typeof ResizeObserver === 'undefined') return
  headerObserver = new ResizeObserver(() => syncHeaderOffset())
  headerObserver.observe(el)
})

onUnmounted(() => headerObserver?.disconnect())
</script>
